import React from 'react';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { styled } from 'dripsy';

import type { Credits } from '@models/Tracks/CreditsModel';
import { OptionItem } from '../common/OptionItem';
import { BaseText } from '@components/common/BaseText';
import type { IPurchaseCreditsModalStore } from '../modals/PurchaseCreditsModal';

export const TAG_ITEM_HEIGHT = 35;

export interface ICreditItemProps {
  item: Credits;
  store: IPurchaseCreditsModalStore;
}

const ChildrenBox = styled(View)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: 1,
});

const Title = styled(BaseText)({
  variant: 'text.medium',
  fontWeight: 'semi',
});
const Price = styled(BaseText)({
  variant: 'text.xxlarge',
  fontWeight: 'semi',
});

const Description = styled(BaseText)({
  variant: 'text.small',
  color: '$text400',
});

export const CreditItem = observer(
  ({ item, store }: ICreditItemProps) => {
    const { t } = useTranslation();
    const isActive = store.chooseCreditOfferId === item.id;

    function onPress() {
      if (isActive) {
        store.setChooseCreditOfferId(null);
      } else {
        store.setChooseCreditOfferId(item.id);
      }
    }

    return (
      <OptionItem onValueChange={onPress} value={isActive}>
        <ChildrenBox>
          <View>
            <Title>
              {t('common.purchaseCredits.number', {
                count: item.count,
              })}
            </Title>
            <Description>
              {t('common.purchaseCredits.validUntil', {
                date: item.formattedExpirationTime,
              })}
            </Description>
          </View>
          <Price>{item.formattedPrice}</Price>
        </ChildrenBox>
      </OptionItem>
    );
  },
);
